<script>
import {  common } from '@/mixins/common';
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { GetApiActionWithAuthorization } from '../../../helpers/apiActions';

export default {
  name: 'Crawler',
  components: {
    Layout,
    PageHeader
  },
  props: {},
  data() {
    return {
        title: 'Duplicate Checker',
        tab: '',
        loadListingChecker: false,
        pageFullyLoaded: true,
        onPageTabLoad: true,
        tableData: [],
        pagination: {
            page_size: 50,
            total: 1,
            page: 1
        },
        columns: [
            {
                key: "sellingPrice",
                value: 'Selling Price',
                sortable: false,
            },
            {
                key: "sellingGram",
                value: 'Selling Gram',
                sortable: false,
            },
            {
                key: "sellingPriceGram",
                value: 'Price / Gram',
                sortable: false,
            }
        ],
        items: [],
        tabs: [
            {
                value: 'Barcodes',
                link: 'barcode/index',
                label: 'barcode_index',
                icon: 'fas fa-list',
                active: false
            },
            {
                value: 'BIN',
                link: 'barcode/bins',
                label: 'barcode_bins',
                icon: 'fas fa-list',
                active: false
            }
        ],
        months: [
            { id: 1, name: "January" },
            { id: 2, name: "February" },
            { id: 3, name: "March" },
            { id: 4, name: "April" },
            { id: 5, name: "May" },
            { id: 6, name: "June" },
            { id: 7, name: "July" },
            { id: 8, name: "August" },
            { id: 9, name: "September" },
            { id: 10, name: "October" },
            { id: 11, name: "November" },
            { id: 12, name: "December" },
        ],
        years: [
            2021,
            2022,
            2023
        ],
        formFilter: {
            day: '',
            month: ((new Date()).getMonth()+1),
            year: new Date().getFullYear()
        },
        view: "year"
    }
  },
  mixins: [
    common
  ],
  methods: {
    getDateLink(date) {
        let _vm = this
        let params = { view: 'month', v: date}
        //
        if (_vm.view === 'month') {
            params.view = 'day'
            params.v = _vm.$route.query.v + '/' + date
        }
        return "?" + (new URLSearchParams(params)).toString()
    },
    updateCurrentPage(page) {
        this.loadPageData({ page })
        let url = window.location.href.split(/[?#]/)[0];    
        url += (url.indexOf('?') > -1) ? "&" : "?";
        url += "page=" + page
        window.history.replaceState({}, "Cybershop v2", url);
    },
    preventTabClick(tab, oldTab) {
      if (typeof oldTab === 'string' && oldTab.length > 1) {
        location.href = '/' + tab.replaceAll('_', '/')
      }
      return this.onPageTabLoad && (oldTab == 0 || !oldTab);
    },
    handleTabClick() {
      this.onPageTabLoad = false
      return this.onPageTabLoad;
    },
    loadPageData(params = { page: 1 }) {
        let _vm = this
        params.view = _vm.view
        params.viewValue = _vm.$route.query.v
        //let data = Object.assign(params, _vm.formFilter)
        return GetApiActionWithAuthorization("admin/orders/get-sold-items?" + (new URLSearchParams(params).toString())).then(res => {
            _vm.tableData = res.data
            _vm.pagination.page_size = res.page_size
            _vm.pagination.total = res.count
            if (res.data.length > 0) {
                _vm.pagination.page = params.page
            }
        });
    },
    findGram (description) {
      let weightInGrams = /(\d*(\.\d+))\s*(g)/.exec(description) || []
      return (weightInGrams.length > 1) ? weightInGrams[1] : 0 // 2 oz in gram
    },
    extractGram (description, defaultGram) {
        let gram = this.findGram(description)
        return gram > 0 ? gram : (defaultGram == 0 ? 2 : defaultGram)
    },
    checkDuplicateListing () {
        let _vm = this
        _vm.loadListingChecker = true
        return GetApiActionWithAuthorization("admin/tools/crawler/check-duplicate-listing").then(() => {
            _vm.loadListingChecker = false
        })
    }
  },
  computed: {},
  mounted () {
    let page = this.$route.query.page || 1
    this.view = this.$route.query.view || 'year'
    this.loadPageData({ page })
    //
    if (this.view=="year"
        || !this.view
        || this.view == "month") {
        this.columns.unshift({
            key: "date",
            value: 'Date',
            sortable: false,
        })
    } else {
        this.columns.unshift({
            key: "name",
            value: 'Product',
            sortable: false,
        })
    }
  }
}
</script>
<template>
    <div class="crawler__content">
        <Layout>
            <PageHeader
                :title="title"
                :items="items"
                icon="bx bx-barcode"
                v-if="title.length > 0"/>
            <div class="setting-page-container pt-4">
                <div class="box-section mb-3 pb-1">
                    <div class="box-section-header">DUPLICATE ACTIVE LISTINGS</div>
                    <div class="box-section-body py-2">
                        <div class="my-3">
                            <b-button
                                variant="primary"
                                @click="checkDuplicateListing()"
                            >
                                <span v-if="!loadListingChecker">Run Checker</span>
                                <span v-else>
                                    <i class="el-icon-loading"></i> Processing
                                </span>
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    </div>
</template>